import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';
import { HttpOptions } from '../Interface/common.interface';

@Injectable({ providedIn: 'root' })
export class HttpService {
  private http = inject(HttpClient);
  private config = inject(ConfigService);

  // Access the URL dynamically
  private get baseUrl() {
    return this.config.settings.apiBaseUrl;
  }

  get<T>(path: string, params: HttpParams = new HttpParams()): Observable<T> {
    return this.http.get<T>(`${this.baseUrl}/${path}`, { params });
  }

  /**
     * POST method
     * @param url API Endpoint URL
     * @param body Data to send
  */
  post<T>(path: string, body: unknown, options?: HttpOptions): Observable<T> {
    return this.http.post<T>(`${this.baseUrl}/${path}`, body, options);
  }

  put<T>(path: string, body: any = {}): Observable<T> {
    return this.http.put<T>(`${this.baseUrl}/${path}`, body);
  }

  patch<T>(path: string, body: any = {}): Observable<T> {
    return this.http.patch<T>(`${this.baseUrl}/${path}`, body);
  }

  delete<T>(path: string): Observable<T> {
    return this.http.delete<T>(`${this.baseUrl}/${path}`);
  }
}
